import { ComboboxAdornment } from './combobox-adornment';
import { ComboboxChipsOverflow } from './combobox-chips-overflow';
import { ComboboxClear } from './combobox-clear';
import { ComboboxContent } from './combobox-content';
import { ComboboxEmptyState } from './combobox-empty-state';
import { ComboboxGroup } from './combobox-group';
import { ComboboxHeading } from './combobox-heading';
import { ComboboxInput } from './combobox-input';
import { ComboboxInputGroup } from './combobox-input-group';
import { ComboboxLoadingState } from './combobox-loading-state';
import { ComboboxOption } from './combobox-option';
import { ComboboxOptionLabel } from './combobox-option-label';
import { ComboboxOptionMedia } from './combobox-option-media';
import { ComboboxOptionMeta } from './combobox-option-meta';
import { ComboboxPortal } from './combobox-portal';
import { ComboboxRoot } from './combobox-root';
import { ComboboxTrigger } from './combobox-trigger';
import type { ComboboxValueType } from './types/combobox-root.types';
import type { ComboboxPropsInterface } from './types/combobox.types';

export const Combobox = <ValueType extends ComboboxValueType>(
  props: ComboboxPropsInterface<ValueType>,
) => {
  const {
    css: cssProp,
    portalId,
    portalRoot,
    portalPreserveTabOrder,
    renderAdornment,
    renderChip,
    renderChipsOverflow,
    renderClear,
    renderEmptyState,
    renderInput,
    renderInputGroup,
    renderGroup,
    renderHeading,
    renderLoadingState,
    renderOption,
    renderOptionLabel,
    renderOptionMedia,
    renderOptionMeta,
    ...rest
  } = props;

  return (
    <Combobox.Root {...rest}>
      <Combobox.Trigger
        renderAdornment={renderAdornment}
        renderChip={renderChip}
        renderChipsOverflow={renderChipsOverflow}
        renderClear={renderClear}
        renderInput={renderInput}
        renderInputGroup={renderInputGroup}
        css={cssProp}
      />
      <Combobox.Portal id={portalId} root={portalRoot} preserveTabOrder={portalPreserveTabOrder}>
        <Combobox.Content
          renderEmptyState={renderEmptyState}
          renderGroup={renderGroup}
          renderHeading={renderHeading}
          renderLoadingState={renderLoadingState}
          renderOption={renderOption}
          renderOptionLabel={renderOptionLabel}
          renderOptionMedia={renderOptionMedia}
          renderOptionMeta={renderOptionMeta}
        />
      </Combobox.Portal>
    </Combobox.Root>
  );
};

Combobox.displayName = 'Combobox';

Combobox.Root = ComboboxRoot;
Combobox.Trigger = ComboboxTrigger;
Combobox.Input = ComboboxInput;
Combobox.InputGroup = ComboboxInputGroup;
Combobox.ChipsOverflow = ComboboxChipsOverflow;
Combobox.Clear = ComboboxClear;
Combobox.Adornment = ComboboxAdornment;
Combobox.Portal = ComboboxPortal;
Combobox.Content = ComboboxContent;
Combobox.Group = ComboboxGroup;
Combobox.Heading = ComboboxHeading;
Combobox.Option = ComboboxOption;
Combobox.OptionLabel = ComboboxOptionLabel;
Combobox.OptionMedia = ComboboxOptionMedia;
Combobox.OptionMeta = ComboboxOptionMeta;
Combobox.EmptyState = ComboboxEmptyState;
Combobox.LoadingState = ComboboxLoadingState;
